import { render, staticRenderFns } from "./SpecialRecommendation.vue?vue&type=template&id=1d347636"
import script from "./SpecialRecommendation.vue?vue&type=script&lang=js"
export * from "./SpecialRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports